import { z } from 'zod';
/**
 * What Postgres itself reports — proof that the API reached the database, not just that it is up. `health.get`
 * is public (container probes call it), so nothing here describes business data.
 */
export const databaseHealthSchema = z.object({
    name: z.string(),
    version: z.string(),
    serverTime: z.string().datetime({ offset: true }),
    appliedMigrations: z.number().int().min(0),
});
export const healthOutputSchema = z.object({
    status: z.literal('ok'),
    db: z.boolean(),
    time: z.string().datetime(),
    /** `null` when the database did not answer. */
    database: databaseHealthSchema.nullable(),
});
//# sourceMappingURL=health.schemas.js.map